import type { DSControlledDateTimePickerT } from '../react-desc-prop-types.js';

const dateTimeTypes = ['full-date-time', 'date-time-inputs', 'date-time-picker', 'date-time-picker-controller-only'];
const dateTypes = ['full-date', 'date-inputs', 'date-picker', 'date-picker-controller-only'];
const timeTypes = ['full-time', 'time-inputs', 'time-picker', 'time-picker-controller-only'];

export const getIsDateTime = (
  props: DSControlledDateTimePickerT.Props | DSControlledDateTimePickerT.InternalProps,
): props is DSControlledDateTimePickerT.DateTimePickerProps | DSControlledDateTimePickerT.InternalDateTimePickerProps =>
  dateTimeTypes.includes(props.type);

export const getIsDate = (
  props: DSControlledDateTimePickerT.Props | DSControlledDateTimePickerT.InternalProps,
): props is DSControlledDateTimePickerT.DatePickerProps | DSControlledDateTimePickerT.InternalDatePickerProps =>
  dateTypes.includes(props.type);

export const getIsTime = (
  props: DSControlledDateTimePickerT.Props | DSControlledDateTimePickerT.InternalProps,
): props is DSControlledDateTimePickerT.TimePickerProps | DSControlledDateTimePickerT.InternalTimePickerProps =>
  timeTypes.includes(props.type);
